import { useEffect } from 'preact/hooks'
import { useParams } from 'wouter-preact'
import { type ComponentChildren } from 'preact'

import {
	getProjectDetailsById,
	getProjects,
	areProjectsLoadingState,
	removeProjectDetail,
	isProjectLoadingState
} from 'state'
import { Header } from 'pages/layout/components/header'

interface Props {
	children: ComponentChildren
}

const DashboardTemplate = ({ children }: Props) => {
	const { projectId } = useParams()

	useEffect(() => {
		if (projectId) {
			getProjects()
			getProjectDetailsById(projectId)
		}
		return () => {
			removeProjectDetail()
		}
	}, [projectId])

	const isLoading = isProjectLoadingState.value || areProjectsLoadingState.value

	return (
		<div class='flex h-screen flex-col bg-black-900'>
			<Header />

			<div class='flex flex-1 overflow-hidden'>
				{isLoading ? (
					<main class='mx-auto flex-1 animate-pulse' />
				) : (
					<main class='flex-1 overflow-y-auto'>{children}</main>
				)}
			</div>
		</div>
	)
}

export { DashboardTemplate }
